import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Calendar as CalendarIcon,
    Plus,
    Filter,
    MoreHorizontal,
    Search,
    ChevronDown,
    Clock,
    MapPin,
    GraduationCap,
    Layout,
    Download
} from 'lucide-react';

export default function AdminTimetable() {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [activeDay, setActiveDay] = useState('Monday');

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Master Timetable"
                    subtitle="Centralized management of faculty schedules and classroom rotations"
                >
                    <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                        <Download size={18} className="text-gray-400" />
                        Export Master
                    </button>

                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Auto-Generate
                    </button>
                </Header>

                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10 min-h-[500px]">
                    <div className="p-8 border-b border-gray-50 space-y-8">
                        <div className="flex items-center justify-between">
                            <h3 className="text-[20px] font-black text-[#111827]">Resource Allocation Matrix</h3>
                            <div className="flex items-center gap-4">
                                <div className="flex gap-2 p-1.5 bg-[#F8FAFC] rounded-[20px] w-fit">
                                    {days.map(d => (
                                        <button
                                            key={d}
                                            onClick={() => setActiveDay(d)}
                                            className={`px-8 py-2.5 rounded-[16px] text-[13px] font-black transition-all ${activeDay === d ? 'bg-white text-blue-500 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600'}`}
                                        >
                                            {d}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <Dropdown label="Select Segment" value="Secondary School" />
                            <Dropdown label="Select Room" value="All Classrooms" />
                            <Dropdown label="Select Teacher" value="Global View" />
                        </div>
                    </div>

                    <div className="p-8 flex-1 flex flex-col items-center justify-center text-center opacity-40 bg-slate-50/30">
                        <div className="w-16 h-16 bg-white border border-gray-100 rounded-2xl flex items-center justify-center shadow-sm mb-4">
                            <Layout size={32} className="text-gray-300" />
                        </div>
                        <h4 className="text-[18px] font-black text-gray-400 tracking-widest uppercase mb-1">Grid Initializing</h4>
                        <p className="text-[13px] font-bold text-gray-300">Select parameters to view the scheduling matrix</p>
                    </div>
                </div>
            </main>
        </div>
    );
}

function Dropdown({ label, value }) {
    return (
        <div className="flex flex-col gap-2">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest px-1">{label}</label>
            <div className="flex items-center justify-between px-5 py-3.5 bg-white border border-gray-100 rounded-2xl cursor-pointer hover:border-blue-200 transition-all font-sans">
                <span className="text-[14px] font-black text-gray-700">{value}</span>
                <ChevronDown size={18} className="text-gray-400" />
            </div>
        </div>
    );
}
